import React from "react";

type CountWidgetProps = {
    count: number;
    singular_text: string;
    multiple_text?: string;
};

function CountWidget({
    count,
    singular_text,
    multiple_text
}: CountWidgetProps) {
    if (count == 1)
        return (
            <span>
                {count} {singular_text}
            </span>
        );
    if (multiple_text)
        return (
            <span>
                {count} {multiple_text}
            </span>
        );
    return (
        <span>
            {count} {singular_text}s
        </span>
    );
}

export {
    CountWidget
}